'use client'
import {
  EnvironmentProvider,
  useEnvironment
} from "./chunk-VMD3UMGK.mjs";
export {
  EnvironmentProvider,
  useEnvironment
};
//# sourceMappingURL=index.mjs.map